  // 历史记录数据结构为：
// [
//     {
//         session_id,
//         data: [
//             {question, content, showType, time},
//             {question, content, showType, time}
//         ]

//     }
// ]
import commonHistory from './commonHistory.mixin'

import { getUserQAList, getUserQA, clearHistoryQa, clearQA} from "@/api/ai.js";
export default {
    mixins: [commonHistory],
    data() {
        return {
            session_hash:'',
            allHistory: [],
            history: [],
            showHistory: [], // 绘制dom的数据
        }
    },
    methods: {
        // 初始化历史记录
        initHistory() {
          getUserQAList(1).then(res => {
            if (res.count == 200) {
              this.allHistory = res.content
              this.createSession()
            } else {
              this.allHistory = []
              this.createSession()
            }
          })
        },
        // 删除单条历史记录
        delSingleHistoty(item) {
            let sessionid = item.RECID
            clearQA(sessionid, 1).then(res => {
              if (res.count == 200) {
                let index = this.allHistory.findIndex(item => item.RECID == sessionid)
                this.allHistory.splice(index ,1)
                // 如果删除的会话式当前会话，需要重新创建会话
                if (this.session_hash == sessionid) {
                  this.isSHowTrace = false
                  this.createSession()
                }
                this.$message.success('会话删除成功！')
              }else {
                this.$message.error('会话删除失败！')
              }
            }).catch(err => {
              this.$message.error('会话删除失败！')
            })
        },
        // 生成用用户请求的历史记录
        generateRequestHistory() {
            let requestHistory = []
            if (this.session_hash) {
                this.history.length > 0 && this.history.forEach((item, index) => {
                    // 历史记录，刚提问的问题，不进入请求历史记录
                    if (index < this.history.length - 1)
                    requestHistory.push({question: item.question, content: item.content})
                });
            }
            return requestHistory
            
        },
        
        // 签出历史记录
        checkoutHistory(id) {
            if (this.isDone == false) {
              this.$message.warning("请先停止打印输出!");
              return
            }
            this.checkList = []
            getUserQA(id).then(res=> {
              if (res.count == 200) {
                const result = res.content
                result.forEach(item => {
                  item.content = item.content.replaceAll('@@', '"');
                  item.content = item.content.replaceAll('\n', '</br>');
                })
                this.history = result
                // 获取最后一条问答的结果溯源
                this.curTrace = this.history.length-1
                let question = this.history[this.curTrace].question
                this.addHoverEventListener()
                this.trace(question)

                // this.transDrawData(res.content)
              }
            }).catch(err => {
              this.history = []
            })
            // this.history = history
          },
        // 清除历史记录
        clearHistory() {
            this.$confirm(`确定删除全部历史记录吗？`)
            .then(() => {
                clearHistoryQa().then(res => {
                    this.isSHowTrace = false
                    this.allHistory = []
                    this.createSession()
                    this.$message.success('历史记录删除成功！')
                }).catch(err => {
                    this.$message.error('历史记录删除失败！')
                })
            })
            .catch(() => {});
        }
    }
}